import React, { useEffect, useRef, useState } from 'react'
import { Form /*Spinner*/ } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import SearchField from '../Forms/SearchField'
import { Observer } from 'mobx-react'
import apiClient from '../../utils/api/apiClient'
import { APIEndpoints } from '../../utils/api/apiConfig'
import { useCancelToken } from '../../utils/hooks/useCancelToken'
import { makeCall } from '../../utils/api/makeCall'
import styled from 'styled-components'
import { MagnifyingGlassIcon } from '../Icons/MagnifyingGlassIcon'
import { colors } from '../../styles/colors'

const SearchWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    justify-content: flex-end;
  }
`
const DesktopSearch = styled(Form.Group)`
  width: 250px;

  @media (max-width: 768px) {
    display: none; /* 👈 hide desktop input on mobile */
  }
`
const MobileSearchIcon = styled.div`
  display: none;
  cursor: pointer;

  @media (max-width: 768px) {
    display: block;
  }
`

const MobileSearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
  // top: 0;
  background: white;
  padding: 6px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease-in-out;
  transform: ${({ isOpen }) => (isOpen ? 'scale(1)' : 'scale(0)')};
  transform-origin: right center;
  z-index: 9999;
  width: 250px;

  input {
    width: 100%;
    font-size: 16px;
    height: 36px; /* fits neatly inside header */
    border-radius: 6px;
    padding: 6px 10px;
  }
  @media (min-width: 769px) {
    display: none; /* hide mobile overlay on desktop */
  }
`
const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${colors.gray2};
  font-size: 20px;
  cursor: pointer;
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;
  border-radius: 50%;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
`

const UniversalSearchBox = () => {
  const [searchText, setSearchText] = useState('')
  const { createOrCancelToken, sourceRef, isCancel } = useCancelToken()
  const [, setErrorStates] = useState({})
  const [, /*loadingStates*/ setLoadingStates] = useState({})
  const navigate = useNavigate()
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false)
  const mobileWrapperRef = useRef(null)
  const mobileInputRef = useRef(null)

  const handleChangeSearchText = (e) => {
    setSearchText(e.target.value)
    startSearch(e.target.value)
  }

  const handleClearClick = (e) => {
    setSearchText('')
  }
  const startSearch = async (searchtext) => {
    createOrCancelToken()
    makeCall(
      'search',
      async () => {
        let response = await apiClient.getJson(
          APIEndpoints.search(searchtext),
          null,
          true,
          true,
          true,
          { cancelToken: sourceRef.current.token }
        )
        if (response.data && response.data.length) {
          setSearchText('')
          navigate(response.data[0].path)
          setIsMobileSearchOpen(false)
        }
      },
      setErrorStates,
      setLoadingStates,
      isCancel
    )
  }
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        isMobileSearchOpen &&
        mobileWrapperRef.current &&
        !mobileWrapperRef.current.contains(e.target)
      ) {
        setIsMobileSearchOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [isMobileSearchOpen])

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setIsMobileSearchOpen(false)
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [])

  useEffect(() => {
    if (isMobileSearchOpen && mobileInputRef.current) {
      mobileInputRef.current.focus()
    }
  }, [isMobileSearchOpen])

  return (
    <Observer>
      {() => (
        <SearchWrapper>
          <DesktopSearch>
            <SearchField
              placeholder=''
              value={searchText}
              onChange={handleChangeSearchText}
              onClearClick={handleClearClick}
            />
            {/*loadingStates.search ? (
          <Spinner
            size='sm'
            className='mt-2'
            animation='border'
            variant='primary'
          />
        ) : null*/}
          </DesktopSearch>
          <MobileSearchIcon
            className='d-md-none'
            onClick={() => setIsMobileSearchOpen(!isMobileSearchOpen)}
          >
            <MagnifyingGlassIcon color={colors.gray2} />
          </MobileSearchIcon>

          <MobileSearchInputWrapper
            ref={mobileWrapperRef}
            isOpen={isMobileSearchOpen}
          >
            <SearchField
              placeholder='Search...'
              value={searchText}
              onChange={handleChangeSearchText}
              onClearClick={handleClearClick}
              onBlur={() => setTimeout(() => setIsMobileSearchOpen(false), 150)}
            />
            <CloseButton onClick={() => setIsMobileSearchOpen(false)}>
              ×
            </CloseButton>
          </MobileSearchInputWrapper>
        </SearchWrapper>
      )}
    </Observer>
  )
}

export default UniversalSearchBox
